// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            &,
            ul,
            ol {
                font-size: inherit;
                line-height: inherit;
                padding: 0 0 0 15px;
                margin: 0;
                list-style-type: none;

                li {
                    padding-left: 10px;
                    padding-bottom: 5px;
                    &:last-child {
                        padding-bottom: 0;
                    }
                    ul,
                    ol {
                        padding-top: 10px;
                        padding-bottom: 5px;
                    }
                }
            }
        `,
    },
    unorderedListProps: {
        css: css`
            &&& {
                list-style: none;
            }

            li {
                &:before {
                    content: "";
                    background: ${getColor("tertiary")};
                    border: 1px solid ${getColor("tertiary")};
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    display: inline-block;
                    margin-left: -20px;
                    margin-right: 15px;
                }

                ul {
                    li:before {
                        background: transparent;
                    }
                }
            }
        `,
    },
    orderedListProps: {
        css: css`
            ol {
                list-style: lower-alpha;
            }
        `,
    },
    listItemProps: {
        css: css`
            & {
                padding: 0;
            }
        `,
    },
} as xBaseTheme["lists"];
